@if (!isAppMobile) {
  <h1 class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
    {{ 'coordonnees.titre' | translate }}
  </h1>
}
<h2 id="titreTelephone" tabindex="-1" class="dsd-t-3 dsd-mb-md">
  {{
    (estTelephoneExistant ? 'modifierTelephones.titreModifier' : 'modifierTelephones.titreAjouter')
      | translate
  }}
</h2>

<dsd-form (dsdFormSubmit)="naviguerVersValidation($event)">
  <p class="dsd-fw-bold dsd-b-40 dsd-mb-md">{{ 'formulaire.ajoutdechamps' | translate }}</p>
  <ng-container [formGroup]="formGroup">
    <dsd-container>
      <dsd-fieldset variant="title">
        <h3 slot="legend" class="dsd-t-4">
          {{ 'modifierTelephones.titrePrincipal' | translate }}
        </h3>
        <dsd-radio-group required="true" name="type" class="dsd-mb-sm">
          <span slot="legend">{{ 'modifierTelephones.typeLegende' | translate }}</span>
          <span slot="error">{{ 'modifierTelephones.erreur.typeVide' | translate }}</span>
          <dsd-radio
            value="CELLULAIRE"
            name="typeAppareilCell"
            (dsdRadioChange)="typeAppareil(telephoneTypeEnum.CELLULAIRE)"
            [checked]="formGroup.get('typeAppareil')?.value === telephoneTypeEnum.CELLULAIRE"
            >{{ 'modifierTelephones.typeCellulaire' | translate }}</dsd-radio
          >
          <dsd-radio
            value="TELEPHONE"
            name="typeAppareilFixe"
            (dsdRadioChange)="typeAppareil(telephoneTypeEnum.TELEPHONE)"
            [checked]="formGroup.get('typeAppareil')?.value === telephoneTypeEnum.TELEPHONE"
            >{{ 'modifierTelephones.typeFixe' | translate }}</dsd-radio
          >
        </dsd-radio-group>
        <div class="dsd-d-flex">
          <dsd-input
            #numeroTelephone
            identifier="numeroTelephone"
            formControlName="numeroTelephone"
            name="numeroTelephone"
            custom-type="cellular"
            required="true"
            class="dsd-mr-sm dsd-mb-0"
          >
            <span slot="label">{{ 'modifierTelephones.numero' | translate }}</span>
            <span slot="hint"></span>
            <span slot="error">
              <span data-error-key="telephoneNombreNonRepete">{{
                'modifierTelephones.erreur.telephoneValide' | translate
              }}</span>
              <span data-error-key="required">{{
                'modifierTelephones.erreur.telephoneVide' | translate
              }}</span>
              <span data-error-key="default">{{
                'modifierTelephones.erreur.telephoneValide' | translate
              }}</span>
            </span>
          </dsd-input>
          @if (estTelephoneFixe()) {
            <dsd-input
              identifier="postePrincipal"
              class="dsd-mb-0"
              formControlName="numeroPoste"
              name="postePrincipal"
              pattern="^\d+$"
              [maxlength]="4"
              type="tel"
            >
              <span slot="label"
                ><span aria-hidden="true">{{ 'modifierTelephones.poste' | translate }}</span
                ><span class="dsd-sr-only">{{
                  'modifierTelephones.horsEcran.poste' | translate
                }}</span></span
              >
              <span slot="error">
                <span data-error-key="maxlength">{{
                  'modifierTelephones.erreur.posteMaxlength' | translate
                }}</span>
                <span data-error-key="pattern">{{
                  'modifierTelephones.erreur.postePattern' | translate
                }}</span>
              </span>
            </dsd-input>
          }
        </div>
      </dsd-fieldset>
    </dsd-container>
  </ng-container>
  <div class="zone-btn">
    <!-- Bouton Confirmer -->
    <dsd-button variant="primary" type="submit" full-width="xs">
      {{ 'bouton.valider' | translate }}
    </dsd-button>
    <!-- Bouton Annuler -->
    <dsd-button full-width="xs" id="btnAnnuler" (dsdButtonClick)="annuler()">
      {{ 'bouton.annuler' | translate }}
    </dsd-button>
  </div>
</dsd-form>
